import { formatPatientAge } from '@/entities/study';
import dayjs from 'dayjs';

/**
 * Derives a patient's displayable age from their date of birth for the solutions drawer. Subtracts the birth year from the current year with dayjs and runs the result through formatPatientAge, returning an empty string when no date of birth is given.
 *
 * @param dob - Patient date of birth.
 * @returns The formatted patient age, or an empty string.
 */
const getAge = (dob: any) => {
  if (dob) {
    const age = dayjs().year() - dayjs(dob).year();
    return formatPatientAge(age);
  }
  return '';
};

export { getAge };
